import './App.css';

import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect, useState } from 'react';


import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

const getInitialTheme = () => {
  const storedTheme = window.localStorage.getItem('portfolio-theme');

  if (storedTheme === 'light' || storedTheme === 'dark') {
    return storedTheme;
  }

  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
};

function App() {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    AOS.init({
      duration: 560,
      easing: 'ease-out-quart',
      offset: 30,
      once: true,
      disable: () => window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.innerWidth < 768,
    });
  }, []);

  useEffect(() => {
    document.body.dataset.theme = theme;
    window.localStorage.setItem('portfolio-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((currentTheme) => (currentTheme === 'dark' ? 'light' : 'dark'));
  };
  
  return (
    <div className={`app-shell theme-${theme}`}>
      <div className="app-orb app-orb-one" />
      <div className="app-orb app-orb-two" />
      <Navbar theme={theme} onToggleTheme={toggleTheme} />
      <main className="relative z-10">
        <Hero />
        <About />
        <Projects />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
